import React, { Component } from "react";
import "./App.scss";
import { MainPage, Header } from "./components";
import { user } from '@myplay/all';
class App extends Component {
  async componentDidMount() {
      user.auth.setLoginUri(process.env.REACT_APP_MYPLAY_IDENTITY_URI);
  }
  render() {
    return (
      <div className="App">
        <Header />
        <MainPage />
      </div>
    );
  }
}

export default App;
